import { CircularProgress } from '@mui/material';
import './UpdateStudentPanel.scss';
import UpdateStudentForm from './UpdateStudentForm';
import { getDataFromIncluded } from '../../../../../hooks/AdminUtilityHooks';
import TeacherTableSelector from './TeacherTableSelector';
import { unique } from '../../../../../../../utils/ArrayUtils';

const UpdateStudentPanel = ({
  loading,
  studentFormData,
  onStudentFormDataChange,
  studentDataObject,
} = {
  loading: false,
  studentFormData: {},
  onStudentFormDataChange: () => null,
  studentDataObject: {
    data: {
      relationships: {
        teachers: [],
      },
    },
  },
}) => {
  const teacherListFromStudentDataObject = getDataFromIncluded(
    studentDataObject && studentDataObject.data.relationships
      ? studentDataObject.data.relationships.teachers.data
      : [], studentDataObject.included || [],
  );

  const studentTeacherSelectorTableData = teacherListFromStudentDataObject.map((st) => ({
    id: st.id,
    username: st.attributes.userName,
    firstName: st.attributes.firstName,
    lastName: st.attributes.lastName,
  }));
  return (
    <div className='update-admin-student-panel'>
      {
        loading ? (
          <div className='loading-student-data'>
            <CircularProgress className='loading-icon' />
            Loading
          </div>
        ) : (
          <>
            <UpdateStudentForm
              studentFormData={studentFormData}
              onDataChange={onStudentFormDataChange}
            />
            <TeacherTableSelector
              studentTeacherSelectorTableData={unique(studentTeacherSelectorTableData, 'id')}
            />
          </>
        )
      }
    </div>
  );
};

export default UpdateStudentPanel;
